/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex'
import { moduleGetterContext, moduleActionContext } from '../index'
import * as Lib from '@/lib/functions/plain'
// import * as types from '@/lib/definition/types'
import moment from "moment-timezone";
moment.locale('ja')

export interface InformationBoardState {
  [key: string]: any;
}

const InformationBoard = defineModule({
  state: (): InformationBoardState => {
    return {
    }
  },
  getters: {
  },
  mutations: {
    SET_VALUE (state, param: { name: string; value: any }) {
      state[param.name] = param.value
    }
  },
  actions: {
    async add(context, { endedTimeGMT, message, url, color, targetTagId, informationBoardId }): Promise<any> {
      const { rootState } = moduleActionContext(context, InformationBoard)
      const retval = await Lib.Ajax.getHandleError<any>('/api/informationboard/add/' + informationBoardId, "Failed to receive Groups", { endedTimeGMT, message, url, color, targetTagId }, rootState.Login.accessToken)
      var groups = retval.data.data
      return groups
    },
    async delete(context, informationBoardId): Promise<any> {
      const { rootState } = moduleActionContext(context, InformationBoard)
      const retval = await Lib.Ajax.getHandleError<any>('/api/informationboard/delete/' + informationBoardId, "Failed to Delete Information ", {}, rootState.Login.accessToken)
      var groups = retval.data.data
      return groups
    },
    async finish(context, informationBoardId): Promise<any> {
      const { rootState } = moduleActionContext(context, InformationBoard)
      const retval = await Lib.Ajax.getHandleError<any>('/api/informationboard/finish/' + informationBoardId, "Failed to Finish Information", {}, rootState.Login.accessToken)
      var groups = retval.data.data
      return groups
    },  
    async listAll(context): Promise<any> {
      const { rootState } = moduleActionContext(context, InformationBoard)
      const retval = await Lib.Ajax.getHandleError<any>('/api/informationboard/listall', "Failed to receive Groups", {}, rootState.Login.accessToken)
      var list = retval.data.data
      list.forEach((element: any) => {
        element.endedGMTM = element.endedTimeGMT == null ? null : moment.tz(element.endedTimeGMT, 'Etc/GMT')
        element.ended = element.endedTimeGMT == null ? null : element.endedGMTM.tz(moment.tz.guess()).format('YYYY-MM-DD HH:mm')
        element.endedShort = element.endedTimeGMT == null ? null : element.endedGMTM.tz(moment.tz.guess()).format('MM/DD dd HH:mm')
        element.endedDate = element.endedTimeGMT == null ? null : element.endedGMTM.tz(moment.tz.guess()).format('YYYY-MM-DD')
        element.endedTime = element.endedTimeGMT == null ? null : element.endedGMTM.tz(moment.tz.guess()).format('HH:mm')
        element.endedTime2 = element.endedTimeGMT == null ? null : element.endedGMTM.tz(moment.tz.guess()).format('HH:mm')
        element.endedClientM = element.endedTimeGMT == null ? null : moment(element.endedClient)
        element.endedClientF = element.endedTimeGMT == null ? null : element.endedClientM.format('YYYY-MM-DD HH:mm')  
      });
      return list
    },
    },
  namespaced: true
})

export default InformationBoard
const loginGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, InformationBoard)

























